import { Link } from "react-router-dom";
import { categories } from "@/mocks/site";
import SectionHeading from "@/components/feature/SectionHeading";

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-10 py-14 md:py-20 bg-background-100">
      <SectionHeading
        eyebrow="Categories"
        title="主题分类 · 按需补课"
        desc="六个常设栏目，覆盖从轻松名场面到严肃案例复盘的全部内容类型。"
        align="center"
      />

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {categories.map((cat, index) => (
          <Link
            key={cat.slug}
            to="/rankings"
            className={`group rounded-lg p-6 border transition-colors ${
              index === 0
                ? "bg-primary-500 border-primary-500 text-background-50"
                : "bg-background-50 border-background-200 hover:border-primary-300"
            }`}
          >
            <div className="flex items-start justify-between gap-4">
              <span
                className={`w-12 h-12 rounded-full flex items-center justify-center text-2xl ${
                  index === 0
                    ? "bg-background-50/20 text-background-50"
                    : "bg-accent-100 text-accent-700"
                }`}
              >
                <i className={cat.icon} />
              </span>
              <span
                className={`text-xs ${
                  index === 0 ? "text-background-100/80" : "text-foreground-400"
                }`}
              >
                {cat.count} 篇
              </span>
            </div>
            <h3
              className={`mt-5 font-heading font-bold text-lg ${
                index === 0 ? "text-background-50" : "text-foreground-950"
              }`}
            >
              {cat.name}
            </h3>
            <p
              className={`mt-2 text-sm leading-relaxed ${
                index === 0 ? "text-background-100/85" : "text-foreground-600"
              }`}
            >
              {cat.desc}
            </p>
            <span
              className={`mt-4 inline-flex items-center gap-1 text-sm font-medium ${
                index === 0
                  ? "text-background-50"
                  : "text-primary-600 group-hover:gap-2 transition-all"
              }`}
            >
              查看内容
              <i className="ri-arrow-right-line" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}